var ecc = require('./ecc');

var Tx = require('./Tx');

var _require = require('./codec'),
    toKeyBuffer = _require.toKeyBuffer,
    toDataString = _require.toDataString;

var _require2 = require('./enum'),
    AccountType = _require2.AccountType;

function newAccount(accountType) {
  return getAccount(ecc.newKeyBuffers(accountType));
}

function newRegularAccount() {
  return newAccount(AccountType.REGULAR_ACCOUNT);
}

function newBankAccount() {
  return newAccount(AccountType.BANK_ACCOUNT);
}

function getAccount(privateKey) {
  if (!privateKey) {
    throw new Error('Private key is required.');
  }

  var publicKey, address; // In case they pass in an object created by ecc.newKeyBuffers

  if (privateKey.privateKey) {
    publicKey = privateKey.publicKey;
    address = privateKey.address;
    privateKey = privateKey.privateKey;
  }

  if (typeof privateKey !== 'string' && !Buffer.isBuffer(privateKey)) {
    throw new Error('Invalid private key. Private key must be a Buffer or a string.');
  } // ensure private key is Buffer


  privateKey = toKeyBuffer(privateKey);

  if (privateKey.length !== 32) {
    throw new Error('Invalid private key length.');
  }

  if (!publicKey || !address) {
    var _ecc$toPubKeyAndAddre = ecc.toPubKeyAndAddressBuffer(privateKey);

    publicKey = _ecc$toPubKeyAndAddre.publicKey;
    address = _ecc$toPubKeyAndAddre.address;
  }

  var sign = function sign(message) {
    return ecc.sign(message, privateKey);
  };

  var signTx = function signTx(txData) {
    return signTransaction(txData, privateKey);
  };

  return {
    address: address,
    publicKey: publicKey,
    privateKey: privateKey,
    sign: sign,
    signTransaction: signTx
  };
}

function signTransaction(txData, privateKey) {
  privateKey = toKeyBuffer(privateKey);
  txData.evidence = txData.evidence || [];
  var evidence = {};
  evidence.pubkey = ecc.toPublicKey(privateKey);
  var tx = new Tx(txData);
  evidence.signature = toDataString(ecc.sign(tx.sigHash, privateKey).signature);
  txData.evidence.push(evidence);

  if (!txData.nonce) {
    txData.nonce = tx.nonce;
  }

  return txData;
}

function verifyTxSignature(tx) {
  var collectSigners = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var evidence = tx.evidence;

  if (!Array.isArray(evidence)) {
    evidence = [evidence];
  }

  var signers = [];
  evidence.forEach(function (e) {
    if (!ecc.verify(tx.sigHash, e.signature, e.pubkey)) {
      throw new Error('Invalid signature.');
    }

    if (collectSigners) {
      signers.push(ecc.toAddress(e.pubkey));
    }
  });

  if (collectSigners) {
    tx.signers = signers;
  }
}

module.exports = {
  signTransaction: signTransaction,
  verifyTxSignature: verifyTxSignature,
  newAccount: newAccount,
  newRegularAccount: newRegularAccount,
  newBankAccount: newBankAccount,
  getAccount: getAccount
};